import { useMemo } from "react";
import { useSelector } from "react-redux";
import {
  rulesForTPatientSurgeryAssessment,
  procedureIpsIdToGroup,
} from "../data";

const defaultAssessment = {
  showForm: false,
  type: null,
  uploadFiles: false,
};

export const useTPatientSurgeryAssessmentRules = () => {
  const { patientSurgery } = useSelector(
    (state) => state.patient.patientSurgery
  );

  const { scheduleEvents } = useSelector(
    (state) => state.patient.scheduleEvent
  );

  const { state, track, procedure, patient } = patientSurgery.data ?? {};

  const { id: ipsId } = patient.user.ips ?? {};
  const { id: procedureParentId } = procedure.procedure ?? {};

  return useMemo(() => {
    const groupKey = procedureIpsIdToGroup[`${procedureParentId}-${ipsId}`];
    if (!groupKey) return defaultAssessment;

    const flowRules = rulesForTPatientSurgeryAssessment[groupKey];
    if (!flowRules) return defaultAssessment;

    const trackRules = flowRules[track];
    if (!trackRules) return defaultAssessment;

    const rule = trackRules[state];
    if (!rule) return defaultAssessment;

    const showForm =
      typeof rule.showForm === "function"
        ? rule.showForm({ scheduleEvents })
        : rule.showForm ?? false;

    return {
      type: rule.type,
      uploadFiles: rule.uploadFiles,
      showForm,
    };
  }, [procedureParentId, ipsId, track, state, scheduleEvents]);
};
